import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KkmDetailsComponent } from './kkm-details/kkm-details.component';
import { TicketPageComponent } from './ticket-page/ticket-page.component';
import { ReportComponent } from './report/report.component';
import { KkmSettingsPageComponent } from './kkm-settings-page/kkm-settings-page.component';
import { NewKkmComponent } from './new-kkm/new-kkm.component';
import { SelectKkmTariffPageComponent } from './select-kkm-tariff-page/select-kkm-tariff-page.component';
import { VpnComponent } from './vpn/vpn.component';
import { RetailPlaceDetailsComponent } from './retail-place-details/retail-place-details.component';
import { RetailPlaceSettingsComponent } from './retail-place-settings/retail-place-settings.component';
import { NewRetailPlaceComponent } from './new-retail-place/new-retail-place.component';
import { NewRetailPlaceResolverService } from './new-retail-place/new-retail-place-resolver.service';
import { DeregisterKkmComponent } from './kkm-operations/deregister-kkm/deregister-kkm.component';
import { ReRegisterKkmComponent } from './kkm-operations/re-register-kkm/re-register-kkm.component';
import { SignSelectedTariffPageComponent } from './sign-selected-tariff-page/sign-selected-tariff-page.component';
import { KkmsPageComponent } from './kkms-page/kkms-page.component';
import { ChangeOfdAgreementComponent } from './change-ofd-agreement/change-ofd-agreement.component';
import { CancelDisconnectionOfdAgreementComponent } from './cancel-disconnection-ofd-agreement/cancel-disconnection-ofd-agreement.component';

const kkmOperations: Routes = [
  {
    path: 'register-kkm',
    component: NewKkmComponent,
  },
  {
    path: 'register-kkm/:kkmId',
    component: NewKkmComponent,
  },
  {
    path: 're-register-kkm/:kkmId', component: ReRegisterKkmComponent,
  },
  {
    path: 'deregister-kkm/:kkmId', component: DeregisterKkmComponent,
  },
  {
    path: 'change-ofd-agreement/:kkmId', component: ChangeOfdAgreementComponent,
  },
  {
    path: 'cancel-disconnection-ofd-agreement/:kkmId', component: CancelDisconnectionOfdAgreementComponent,
  },
];

const routes: Routes = [
  {
    path: '', component: KkmsPageComponent,
  },
  ...kkmOperations,
  {
    path: 'add-retail-place',
    component: NewRetailPlaceComponent,
    resolve: {
      bp: NewRetailPlaceResolverService,
    },
  },
  {
    path: ':id', component: KkmDetailsComponent,
  },
  {
    path: ':id/tickets/:tid', component: TicketPageComponent,
  },
  {
    path: ':id/xreport/:rid', component: ReportComponent,
  },
  {
    path: ':id/zreport/:rid', component: ReportComponent,
  },
  {
    path: ':id/settings', component: KkmSettingsPageComponent,
  },
  {
    path: ':id/tariffs', component: SelectKkmTariffPageComponent,
  },
  {
    path: ':id/tariffs/:tariffId', component: SignSelectedTariffPageComponent,
  },
  {
    path: 'add-vpn/:id', component: VpnComponent,
  },
  {
    path: 'retailPlace/:id', component: RetailPlaceDetailsComponent,
  },
  {
    path: 'retailPlace/:id/settings', component: RetailPlaceSettingsComponent,
  },
  {
    path: 'retailPlace/:retailPlaceId/edit',
    component: NewRetailPlaceComponent,
    resolve: {
      bp: NewRetailPlaceResolverService,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class KkmsRoutingModule {
}
